<div class="inner-content">
  <div class="flex items-center justify-between">
    <div class="flex flex-row items-center gap-2">
      <ion-icon class="title-icon" icon="assets/icon/upload-blue-circle.svg"></ion-icon>
      <div class="title barlow">
        Subiendo documentos
        <span *ngIf="printProduct">a {{ printProduct.product?.folderName }}</span>
      </div>
    </div>
    <ion-icon class="close-icon cursor-pointer" icon="assets/icon/cross.svg" (click)="cancel()"></ion-icon>
  </div>
  <hr />
  <div class="w-100">
    <ion-label class="label barlow"> {{ uploadedFiles }}/{{ files.length }} documentos subidos </ion-label>
    <div class="progress-bar-container w-100" [class.is-pending]="progress === 0">
      <div class="progress-bar" [ngStyle]="{ width: progress + '%' }" [class.completed]="progress === 100"></div>
    </div>
    <span class="progressText">{{ progressText }}</span>
  </div>
  <hr />
  <div class="w-100 flex flex-row justify-end gap-2.5">
    <ion-button [disabled]="progress === 100" fill="clear" color="dark" class="underline" (click)="cancel()">
      Cancelar subida
    </ion-button>
  </div>
</div>
